import api from '@/apis'
import { mockDelay } from '@/apis/mockDelay'
import { IS_MOCK } from '@/constants'
import type { GachaDrawResponse } from '@/types/gacha'

import { MOCK_DRAW_RESULT_FAIL, MOCK_DRAW_RESULT_WIN } from './mocks'

export const apiPostGachaDraw = async (gachaEventId: number): Promise<GachaDrawResponse> => {
  if (IS_MOCK) {
    await mockDelay(500)
    return Math.random() > 0.5 ? MOCK_DRAW_RESULT_WIN : MOCK_DRAW_RESULT_FAIL
  }
  return await api.post<GachaDrawResponse>(`/gachas/${gachaEventId}/draw`)
}
